import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  constructor() {}

  getCurrency() {
    return localStorage.getItem('restaurant_currency');
  }
}
